/**
 * package: com.inq.flash.client.chatskins
 * class: VideoMgr
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.VideoMgr = function() {

     //TODO: place functions here, so no need to write in haxe way
    /*function fun1() {

    } */

    return {
        //fun1: fun1
    }
}();

com.inq.flash.client.chatskins.VideoMgr.init = function() {
    com.inq.flash.client.chatskins.VideoMgr.customerAcceptsVideo = com.inq.utils.Util.getConfig("customerAcceptsVideo","Customer accepts video-chat invitation.");
    com.inq.flash.client.chatskins.VideoMgr.customerDeclinesVideo = com.inq.utils.Util.getConfig("customerDeclinesVideo","Customer declines video-chat invitation.");
    com.inq.flash.client.chatskins.VideoMgr.customerStopsVideo = com.inq.utils.Util.getConfig("customerStopsVideo","Customer stops video-chat.");

    com.inq.flash.client.control.FlashPeer.setCiFunction("ciAcceptVideoInv",com.inq.flash.client.chatskins.VideoMgr.acceptVideo);
    com.inq.flash.client.control.FlashPeer.setCiFunction("ciDeclineVideoInv",com.inq.flash.client.chatskins.VideoMgr.declineVideo);
    com.inq.flash.client.control.FlashPeer.setCiFunction("ciStopVideo",com.inq.flash.client.chatskins.VideoMgr.stopVideo);
};


com.inq.flash.client.chatskins.VideoMgr.acceptVideo = function() {
    com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendVideoMessage(com.inq.flash.client.chatskins.VideoMgr.customerAcceptsVideo, com.inq.flash.client.data.MessageFields.DATA_CLIENT_VIDEO_ACCEPT);
};

com.inq.flash.client.chatskins.VideoMgr.declineVideo = function() {
    com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendVideoMessage(com.inq.flash.client.chatskins.VideoMgr.customerDeclinesVideo, com.inq.flash.client.data.MessageFields.DATA_CLIENT_VIDEO_DECLINE);
};

com.inq.flash.client.chatskins.VideoMgr.stopVideo = function() {
    com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendVideoMessage(com.inq.flash.client.chatskins.VideoMgr.customerStopsVideo, com.inq.flash.client.data.MessageFields.DATA_CLIENT_VIDEO_STOP);
};

com.inq.flash.client.chatskins.VideoMgr.customerAcceptsVideo = null;
com.inq.flash.client.chatskins.VideoMgr.customerDeclinesVideo = null;
com.inq.flash.client.chatskins.VideoMgr.customerStopsVideo = null;

